import React from 'react';
import {
    IconCheck,
    IconClock,
    IconRotateClockwise,
    IconSend,
    IconX,
} from '@tabler/icons-react';
import { SimpleGrid } from '@mantine/core';

import { PriceSyncStatCard } from './PriceSyncStatCard';
import type { PriceSyncQueueStats } from './priceSync.types';

type PriceSyncStatsGridProps = {
    stats: PriceSyncQueueStats;
};

export function PriceSyncStatsGrid({ stats }: PriceSyncStatsGridProps) {
    return (
        <SimpleGrid cols={{ base: 2, sm: 3, lg: 5 }} spacing="md">
            <PriceSyncStatCard
                label="Pending"
                value={stats.pending}
                color="blue"
                icon={<IconClock size={22} />}
            />
            <PriceSyncStatCard
                label="Sending"
                value={stats.sending}
                color="indigo"
                icon={<IconSend size={22} />}
            />
            <PriceSyncStatCard
                label="Failed (retryable)"
                value={stats.failedRetryable}
                color={stats.failedRetryable > 0 ? 'red' : 'gray'}
                icon={<IconRotateClockwise size={22} />}
            />
            <PriceSyncStatCard
                label="Failed (exhausted)"
                value={stats.failedExhausted}
                color={stats.failedExhausted > 0 ? 'red' : 'gray'}
                icon={<IconX size={22} />}
            />
            <PriceSyncStatCard
                label="Sent (last 24 h)"
                value={stats.sentLast24h}
                color="green"
                icon={<IconCheck size={22} />}
            />
        </SimpleGrid>
    );
}
